import axios from 'axios'
import { ExternalTokensModel, MonitorModel, QueueModel, RelayDetailModel, RelayerModel, RelaysModel } from 'src/constants/DataModels'
import { RequestDataParams } from 'src/components/Tables/ServerTable'

const rootUrl =
  process.env.REACT_APP_API_ENDPOINT || 'https://bridge-explorer-api.carbon.network'

const API = axios.create({
  baseURL: `${rootUrl}`,
  headers: { 'Cache-Control': 'no-cache' },
})

export function formatParamsForApi(params: RequestDataParams) {
  const formatted: Record<string, string> =  {
    offset: params.offset.toString(),
    limit: params.limit.toString(),
    ...params.filter,
  }
  if (params.sort && params.sort.length !== 0) {
    formatted['sort'] = params.sort.map(s => (s.desc ? `-${s.id}` : s.id)).join(',')
  }

  return formatted
}

export async function fetchExternalTokensData(
  queryParams: Record<string, any>
) {
  return fetchData<ExternalTokensModel>('external_tokens', queryParams)
}

export async function fetchRelaysData(
  queryParams: Record<string, any>
) {
  return fetchData<RelaysModel>('relays', queryParams)
}

export async function fetchRelay(id: string) {
  return await API.get<RelayDetailModel>(`/relays/${id}`)
}

export async function fetchMonitors(
  queryParams: Record<string, any>
) {
  return await fetchData<MonitorModel>('monitors', queryParams)
}

export async function fetchRelayers(
  queryParams: Record<string, any>
) {
  return await fetchData<RelayerModel>('relayers', queryParams)
}

export async function fetchQueues(
  queryParams: Record<string, any>
) {
  return await fetchData<QueueModel>('queues', queryParams)
}

async function fetchData<T>(endpoint: string, queryParams: Record<string, any>) {
  const queryString = new URLSearchParams(queryParams).toString()
  return await API.get<T>(`/${endpoint}?${queryString}`)
}

export default API
